import { createApp } from 'vue'
import Catalog from '@/js/it-vacancies/vacancies/Catalog'
import store from '@/js/store'

createApp(Catalog).use(store).mount('#vacancies-catalog')
